export enum WellKnownNotificationHubUrls {
  eventHub = 'hubs/eventHub',
}
